module.exports = __webpack_public_path__ + "static/images/matchbg2.7dbd843.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/matchbg2.jpg
// module id = u/hN
// module chunks = 1